import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchUserOrders } from 'registry/actions'
import { LoadingHeart } from 'baby-design'
import { StyledSubHeading } from 'components/headings'
import {
  getOrders,
  getIsFetchingUserOrders,
  getOrdersHasError,
} from 'registry/reducers'
import css from './with-your-orders.styles.scss'

const withYourOrders = (WrappedComponent) => {
  class WithYourOrders extends Component {
    componentDidMount() {
      const { onLoad } = this.props
      onLoad()
    }

    render() {
      const { orders, isFetchingUserOrders, hasError, webView } = this.props

      return (
        <div id="your-orders">
          {!webView && <StyledSubHeading>Your Orders</StyledSubHeading>}
          {isFetchingUserOrders ? (
            <LoadingHeart className={css.Loading} />
          ) : (
            <WrappedComponent orders={orders} hasError={hasError} />
          )}
        </div>
      )
    }
  }

  WithYourOrders.defaultProps = {
    hasError: false,
    isFetchingUserOrders: true,
    orders: [],
  }

  WithYourOrders.propTypes = {
    hasError: PropTypes.bool,
    onLoad: PropTypes.func.isRequired,
    isFetchingUserOrders: PropTypes.bool,
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        createdAt: PropTypes.string,
        orderItems: PropTypes.arrayOf(PropTypes.object),
        reference: PropTypes.string,
        returnWebUrl: PropTypes.string,
        statusWebUrl: PropTypes.string,
        total: PropTypes.number,
        trackingInfos: PropTypes.arrayOf(PropTypes.object),
      })
    ),
    webView: PropTypes.bool,
  }

  const mapStateToProps = (state, ownProps) => {
    return {
      ...ownProps,
      hasError: getOrdersHasError(state),
      isFetchingUserOrders: getIsFetchingUserOrders(state),
      orders: getOrders(state),
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onLoad: () => {
        dispatch(fetchUserOrders())
      },
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithYourOrders)
}

export default withYourOrders
